import { createRoot } from 'react-dom/client';
import React from 'react';
import Search from './react/Search';

document.querySelectorAll('.js-autocomplete').forEach(($autocomplete) => {
  const { suggest, suggestFieldName } = $autocomplete.dataset;
  if (!suggest) {
    console.warn(
      'The data-suggest attribute on the search field is missing. Not initializing the search component.'
    );
    return;
  }

  if (suggest && !suggestFieldName) {
    console.warn(
      'No data-suggest-field-name attribute on the search field found. Using default tx_solr[queryString] here.'
    );
  }

  const $form = $autocomplete.closest('.search') || $autocomplete.parentElement;
  const $parent = $form?.parentElement;
  const $label = $parent.querySelector('label');
  const placeholder = $autocomplete.getAttribute('placeholder');
  const name = $autocomplete.getAttribute('name');
  const value = $autocomplete.getAttribute('value');
  const $suggestionItems = $parent?.querySelectorAll('.search__list-item a');
  const suggestionItems = $suggestionItems
    ? Array.from($suggestionItems).map(($item) => $item.textContent)
    : [];
  const formProps = {
    action: $form?.getAttribute('action') || suggest,
    method: $form?.getAttribute('method'),
  };
  const $button = $form?.querySelector('.button[type="submit"]');
  const buttonStyleModifier = $button
    ? Array.from($button.classList)
        .filter((className) => className.startsWith('button--'))
        .map((className) => className.replace('button--', ''))
        .find((modifier) =>
          ['primary', 'secondary', 'chromeless', 'icon'].includes(modifier)
        )
    : undefined;
  const buttonText = $button?.querySelector('.button__text')?.textContent;

  try {
    const root = createRoot($parent);
    root.render(
      <Search
        suggestUrl={suggest}
        suggestFieldName={suggestFieldName || 'tx_solr[queryString]'}
        placeholder={placeholder}
        name={name || 'search'}
        label={$label?.textContent}
        suggestionItems={suggestionItems}
        formProps={formProps}
        hideSubmit={!$button}
        tag={$form?.tagName?.toLowerCase() || 'form'}
        value={value}
        submitButtonProps={{ style: buttonStyleModifier, children: buttonText }}
      />
    );
  } catch (e) {
    console.error(e);
  }
});
